import {h, Component} from "preact";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

import ManagerUserlist from "./manager-userlist";
import ManagerBetslist from "./manager-betslist";
import ManagerStructurelist from "./manager-structurelist";
import {ManagerTransactionHistory} from "./manager-transaction-history";
import {UserTransactions} from "./menu-dashboard";
import ManagerReport from "./manager-report";
import AwrabetManagerLayout from "../../../awrabet/desktop-components/user/manager-layout.jsx";

export default class ManagerLayout extends AwrabetManagerLayout {
    render() {
        const CurrentComponent = this.state.currentcomponent;
        return <div class="max-w-7xl mx-auto min-h-[inherit] bg-slate-200 text-black">
			<div class="main-content-container flex flex-row bg-slate-100 text-black min-h-[inherit]">
				<div class="logged-affiliate-admin-menu panel w-56 shrink-0" style="min-height:500px">
					{this.state.menu.map(
						menu => <ul>
							<li><span class="logged-affiliate-admin-menu-label block uppercase text-sm p-1 ml-2 mt-3 mb-2">{menu.label}</span></li>
							{menu.entries.map(
								entry => <li>
									<a
										href="javascript:void(0);"
										onClick={e => this.setState({currentpage: entry.url, currentcomponent: entry.component})}
										class={"logged-affiliate-admin-menu-item block text-sm py-1 px-2 font-bold ml-6" + (entry.url === this.state.currentpage? ' active after:inline-block after:leading-5 after:text-sm after:float-right' : '')}
									>
										{entry.label}
									</a>
								</li>
							)}
						</ul>
					)}
				</div>
				<div id="user-menu-page" class="logged-affiliate-admin-page bg-white w-full text-gray-900 overflow-x-auto">
					{!!CurrentComponent && <CurrentComponent key={this.state.currentpage} />}
				</div>
			</div>
		</div>;
    }
}